module.exports = __webpack_public_path__ + "img/noctua.8daf6e38.webp";